module.exports = __webpack_public_path__ + "static/media/tf-preloader.49748f09.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tf-preloader.gif
// module id = 485
// module chunks = 0